<template>
  <el-dialog title="紫外线"
             :visible.sync="params.flag"
             v-dialogDrag
             :modal="false"
             :close-on-click-modal="false"
             :lock-scroll="false"
             :modal-append-to-body=false
             :append-to-body="false"
             ref="jsfxRef"
  >
    <div class="main">
        <ultraviolet-rays ref="ultravioletRays" ultravioletRaysChartId="ultraviolet-rays-chart-p"></ultraviolet-rays>
    </div>
  </el-dialog>
</template>
<script>
import UltravioletRays from '@/components/module/card/ultraviolet-rays.vue'

export default {
  components: { UltravioletRays },
  props: ['params'],
  data () {
    return {
      rootFontSize: window.rootFontSize
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
          this.$refs.ultravioletRays && this.$refs.ultravioletRays.resetEchart()
        }
      },
      immediate: true
    }
  },
  computed: {},
  mounted () {
    this.setZindex()
    this.$refs.ultravioletRays && this.$refs.ultravioletRays.resetEchart()
  },
  methods: {
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.jsfxRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }

}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    pointer-events: auto;
  }
}
</style>
